<template>
    <section class="top-brands-wrap clearfix container">
        <div style="margin-bottom:50px;"  class="container">
            <div style="margin-bottom:30px;" class="tab-products-header clearfix">
                <h2 class="section-title float-left">Boutiques <b>Officielles</b></h2> 
           
            </div>

             <a
                :href="banner.call_to_action_url"
                class="banner"
                :target="banner.open_in_new_window ? '_blank' : '_self'"
            >
                <img :src="banner.image.path" alt="UCANbe Tunisie">
            </a>

        </div>
        <div class="container">
            <div class="top-brands clearfix">
                <a
                    v-for="(topBrand, index) in topBrands"
                    :key="index"
                    :href="topBrand.url"
                    class="top-brand-image"
                >
                    <img :src="topBrand.logo.path" alt="UCANbe Tunisie">
                </a>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        props: ['topBrands','banner'],
    };
</script>
